import React from 'react';

import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import { setupAuthFetchInterceptor } from './auth/session.js';
import { setupDevelopment } from './config/development.js';
import { setupNumberInputs } from './setup/numberInputs.js';
import { setupServiceWorker } from './setup/serviceWorker.js';


// Configurar entorno de desarrollo
setupDevelopment();
setupNumberInputs();
setupAuthFetchInterceptor();

async function bootstrap() {
  await setupServiceWorker();

  const root = createRoot(document.getElementById('root'));

  root.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
}

bootstrap();